import { useState } from "react";

export default function TransactionCard({ txn }) {
  const [open, setOpen] = useState(false);

  const statusColor = {
    SUCCESS: "text-green-400",
    PENDING: "text-yellow-400",
    FAILED: "text-red-400",
  };

  return (
    <div
      onClick={() => setOpen(!open)}
      className="bg-[#1f1f1f] rounded-xl p-4 cursor-pointer"
    >
      {/* Top Row */}
      <div className="flex justify-between items-center">
        <div>
          <p className="font-medium">{txn.title}</p>
          <p className="text-xs text-gray-400">{txn.createdAt}</p>
        </div>

        <div className="text-right">
          <p className="font-semibold">₹{txn.amount}</p>
          <p className={`text-xs ${statusColor[txn.status]}`}>
            {txn.status}
          </p>
        </div>
      </div>

      {/* Expanded */}
      {open && (
        <div className="mt-3 border-t border-gray-800 pt-3 text-sm text-gray-300 space-y-1">
          <p>UTR: <span className="text-white">{txn.utr}</span></p>
          <p>Coins: +{txn.coins}</p>

          {txn.status === "PENDING" && (
            <p className="text-yellow-400 text-xs">
              Verification in progress
            </p>
          )}

          {txn.status === "FAILED" && (
            <p className="text-red-400 text-xs">
              Payment verification failed
            </p>
          )}
        </div>
      )}
    </div>
  );
}